import React, { Component } from "react";
import Input from "../common/Input";
import add from "../assets/add.svg";
import close from "../assets/close.svg";

import { Redirect } from "react-router-dom";
import BackArrow from "../common/BackArrow";
import API from "../common/Api";
import { connect } from "react-redux";
import { Shimmer } from "react-shimmer";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import CheckBox from "../common/Check-box";
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state) => ({
  headers: state.headers(),
  business: state.business,

});
class ManageCategories extends Component {
  state = {
    addFormIsOpen: false,
    editForm: true,
    categories: [],
    is_from_service_add: false,
    is_from_service_edit: false,
    services: [],
    selectedCat: {},
    selectedServices: [],
    isLoading: true,
  };

  componentDidMount = () => {
    this.getCategories();
    this.getServices();
    const { history, match, location } = this.props;
    if (match.params.action === 'add') {
      this.setState({ is_from_service_add: true })
      if (!this.state.addFormIsOpen) {
        this.openAddServiceForm();
      }
    } else if (match.params.action !== "" && match.params.action !== undefined) {
      //for edit
      this.setState({ is_from_service_edit: true })
      if (!this.state.addFormIsOpen) {
        this.openAddServiceForm();
      }
    }
     
  }


  openAddServiceForm = (data) => {
    this.setState({ editForm: false, selectedCat: {}, addFormIsOpen: true, selectedServices: [] });

  };
  editCatHandle(cat) {
    this.setState({ editForm: true, selectedCat: cat, addFormIsOpen: true, selectedServices: cat.services });
  }
  getServices = () => {
    API.get("business/services", { headers: this.props.headers }).then(
      ({ data }) => {
        this.setState({
          services: data.data.services,
          isLoading: false,
        });
      }
    );
  };



  handleCheckboxChange = (event) => {
    const id = parseInt(event.target.value); // assuming service.id is a number
    const { selectedServices } = this.state;

    const updatedServices = event.target.checked
      ? [...selectedServices, id]
      : selectedServices.filter(serviceId => serviceId !== id);

    this.setState({ selectedServices: updatedServices });
  };

  createCategory = (ev) => {
    ev.preventDefault();
    this.setState({
      is_loading: true,
    });
    const form = ev.currentTarget;
    //  
    // return;
    let newCate = {
      name: form.name.value,
      services: this.state.selectedServices,
    };
    if (this.state.editForm) {
      API.put(
        `categories/${this.state.selectedCat.id}`, newCate,
        { headers: this.props.headers }
      ).then(({ data }) => {
        if (data.success) {
          window.$.notify(
            `Category "${newCate.name}" updated successfully!`,
            "success-alert"
          );
          this.getCategories();
          form.reset();
          this.closeAddServiceForm();

        }
      }).finally(() => {
        this.setState({
          is_loading: false,
        });
      });
    } else {
      API.post(
        "categories", newCate,
        { headers: this.props.headers }
      ).then(({ data }) => {
        if (data.success) {
          window.$.notify(
            `Category "${newCate.name}" created successfully!`,
            "success-alert"
          );
          this.getCategories();
          form.reset();
          this.closeAddServiceForm();

        }
      }).finally(() => {
        this.setState({
          is_loading: false,
        });
      });
    };
  }
  getCategories = () => {
    API.get("categories", { headers: this.props.headers }).then(
      ({ data }) => {
        this.setState({
          categories: data.data,
          isLoading: false,
        });
      }
    );
  };



  deleteCate = (cat) => {

    const options = {
      title: 'Confirm Delete',
      message: `Are you sure you want to permanently delete this category: ${cat.name}?      `,
      buttons: [
        {
          label: 'Yes, Delete',
          className: 'btn btn-danger',

          onClick: () => {


            API.delete(
              `categories/${cat.id}`,
              { headers: this.props.headers }
            ).then(({ data }) => {
              window.$.notify("Category deleted successfully", "success-alert");
              this.getCategories();
            });

          }
        },
        {
          label: 'No, Cancel',
          onClick: () => ""
        }
      ],

      overlayClassName: "overlay-custom-class-name"
    };

    confirmAlert(options);

  }

  closeAddServiceForm = () => {

    if (this.state.is_from_service_add) {
      this.props.history.push({
        pathname: "/services/settings/add_service",
      });
    }
    if (this.state.is_from_service_edit) {

      const { match } = this.props;
      this.props.history.push({
        pathname: "/services/settings/" + match.params.action,
      });
    }

    this.setState({ editForm: false, addFormIsOpen: false, is_loading: false, selectedServices: [] })

  };

  closeAddForm = () => {
    this.setState({ addFormIsOpen: false });
  };

  render() {

    return (
      <>


        {this.state.addFormIsOpen ?
          <div className="dsk-modal-rapper">
            <button
              className="absolute-bg"
              onClick={this.closeAddServiceForm}
            ></button>

            <div className="dsk-modal manage-cate-page container">
              {window.innerWidth >= 600 ? (
                <button onClick={this.closeAddServiceForm}
                  className="close-btn wrapper dsk" style={{ marginTop: '20px' }}
                >
                  <img src={close} alt="" srcSet="" />
                </button>
              ) : (
                ""
              )}

              <div className="wrapper ">

                <div className="section-header flex space-btw">
                  <p className="section-title flex center">
                    {" "}
                    <BackArrow backFunction={this.closeAddServiceForm} className="mbl" />
                    {this.state.editForm ? "Edit this category" : "Add new category"}
                  </p>
                </div>
                <div className="details card">
                  <form
                    onSubmit={this.createCategory}
                  >
                    <Input
                      label="Category name"
                      placeholder="" defaultValue={this.state.selectedCat.name}
                      name="name"
                      required
                    />
                    <div>
                      <h1 className="check_box_title">Services in the category</h1>
                      {this.state.services.map((service) =>
                      (
                        <CheckBox
                          key={service.id}
                          label={service.name}
                          value={service.id}
                          name="services[]"
                          onChange={this.handleCheckboxChange}
                          checked={this.state.selectedServices.includes(service.id)}
                        />
                      ))}


                    </div>
                    <div className="footer flex space-btw">
                      <br />
                      <button
                        className={`default ${this.state.is_loading ? "loading" : ""
                          }`}
                      >
                        {this.state.editForm ? "Update Category" : "Add Category"}

                      </button>
                    </div>
                  </form>
                </div>

              </div>

            </div>
          </div> :
          ""
        }

        {(window.innerWidth < 600 && this.state.addFormIsOpen) === false || window.innerWidth >= 600 ?
          <div className="onboarding-page app-setting">
            {this.state.redirect ? <Redirect to={this.state.redirect} /> : ""}

            <div className="form_step form-page">
              <div className="header flex space-btw center">
                <h1 className="form-title flex center">
                  <BackArrow />
                  Categories
                </h1>

                {this.addFormIsOpen ? (
                  ""
                ) : (
                  <button className="co-pink add" onClick={this.openAddServiceForm}>
                    <img src={add} alt="" />
                    Add another category
                  </button>
                )}
              </div>

              {/* all services */}
              <div
                className="card-container"     >
                <div className="form-container  manage_categories app-setting">

                  {this.state.isLoading ? (
                    <>
                      <Shimmer className="r-shimer-service" height={91} />
                      <Shimmer className="r-shimer-service" height={91} />
                      <Shimmer className="r-shimer-service" height={91} />
                      <Shimmer className="r-shimer-service" height={91} />
                      <Shimmer className="r-shimer-service" height={91} />
                      <Shimmer className="r-shimer-service" height={91} />
                    </>
                  ) : (
                    ""
                  )}

                  <div className="cards col-md">




                    {this.state.categories.length === 0 ?
                      <div style={{ textAlign: 'center' }} >
                        <br />
                        <p className="off">No categories have been created.</p>
                      </div> :
                      <>{this.state.categories.map((cat) => (
                        <div className="card">
                          <div className="flex space-btw">
                            <div className="title">{cat.name}</div>
                            <div className="service_count mobile_only">{cat.services?.length} service{cat.services?.length !== 1 ? 's' : ''}</div>
                          </div>
                          <div className="controls">
                            <div className="service_count web_only">{cat.services?.length} service{cat.services?.length !== 1 ? 's' : ''}</div>
                            <button type="button" onClick={() => { window.copyToClipboard(`https://kindlybook.me/${this.props.business.username}/cat_${cat.id}`) }}

                            >
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.1098 15.39L8.22984 19.27C7.76007 19.7233 7.1327 19.9767 6.47984 19.9767C5.82698 19.9767 5.1996 19.7233 4.72984 19.27C4.49944 19.0405 4.31663 18.7678 4.19189 18.4675C4.06715 18.1671 4.00294 17.8452 4.00294 17.52C4.00294 17.1948 4.06715 16.8728 4.19189 16.5725C4.31663 16.2722 4.49944 15.9995 4.72984 15.77L8.60984 11.89C8.79814 11.7017 8.90393 11.4463 8.90393 11.18C8.90393 10.9137 8.79814 10.6583 8.60984 10.47C8.42153 10.2817 8.16614 10.1759 7.89984 10.1759C7.63353 10.1759 7.37814 10.2817 7.18984 10.47L3.30984 14.36C2.52819 15.2108 2.10546 16.3306 2.12991 17.4857C2.15436 18.6408 2.62412 19.7418 3.44107 20.5587C4.25802 21.3757 5.359 21.8454 6.51408 21.8699C7.66917 21.8944 8.78904 21.4716 9.63984 20.69L13.5298 16.81C13.6231 16.7167 13.697 16.606 13.7475 16.4842C13.798 16.3624 13.8239 16.2318 13.8239 16.1C13.8239 15.9681 13.798 15.8375 13.7475 15.7157C13.697 15.5939 13.6231 15.4832 13.5298 15.39C13.4366 15.2967 13.3259 15.2228 13.2041 15.1723C13.0823 15.1219 12.9517 15.0959 12.8198 15.0959C12.688 15.0959 12.5574 15.1219 12.4356 15.1723C12.3138 15.2228 12.2031 15.2967 12.1098 15.39ZM20.6898 3.30997C19.8486 2.47398 18.7108 2.00476 17.5248 2.00476C16.3389 2.00476 15.2011 2.47398 14.3598 3.30997L10.4698 7.18997C10.3766 7.28321 10.3026 7.3939 10.2522 7.51572C10.2017 7.63755 10.1757 7.76811 10.1757 7.89997C10.1757 8.03183 10.2017 8.1624 10.2522 8.28422C10.3026 8.40604 10.3766 8.51673 10.4698 8.60997C10.5631 8.70321 10.6738 8.77717 10.7956 8.82763C10.9174 8.87809 11.048 8.90406 11.1798 8.90406C11.3117 8.90406 11.4423 8.87809 11.5641 8.82763C11.6859 8.77717 11.7966 8.70321 11.8898 8.60997L15.7698 4.72997C16.2396 4.2766 16.867 4.02323 17.5198 4.02323C18.1727 4.02323 18.8001 4.2766 19.2698 4.72997C19.5002 4.95946 19.683 5.23218 19.8078 5.53249C19.9325 5.8328 19.9967 6.15479 19.9967 6.47997C19.9967 6.80516 19.9325 7.12714 19.8078 7.42745C19.683 7.72776 19.5002 8.00049 19.2698 8.22997L15.3898 12.11C15.2961 12.2029 15.2217 12.3135 15.1709 12.4354C15.1202 12.5573 15.094 12.688 15.094 12.82C15.094 12.952 15.1202 13.0827 15.1709 13.2045C15.2217 13.3264 15.2961 13.437 15.3898 13.53C15.4828 13.6237 15.5934 13.6981 15.7153 13.7489C15.8371 13.7996 15.9678 13.8258 16.0998 13.8258C16.2318 13.8258 16.3626 13.7996 16.4844 13.7489C16.6063 13.6981 16.7169 13.6237 16.8098 13.53L20.6898 9.63997C21.5258 8.79875 21.995 7.66095 21.995 6.47497C21.995 5.289 21.5258 4.15119 20.6898 3.30997ZM8.82984 15.17C8.92328 15.2627 9.03409 15.336 9.15593 15.3857C9.27777 15.4355 9.40823 15.4607 9.53984 15.46C9.67144 15.4607 9.80191 15.4355 9.92374 15.3857C10.0456 15.336 10.1564 15.2627 10.2498 15.17L15.1698 10.25C15.3581 10.0617 15.4639 9.80627 15.4639 9.53997C15.4639 9.27367 15.3581 9.01828 15.1698 8.82997C14.9815 8.64167 14.7261 8.53588 14.4598 8.53588C14.1935 8.53588 13.9381 8.64167 13.7498 8.82997L8.82984 13.75C8.73611 13.8429 8.66171 13.9535 8.61095 14.0754C8.56018 14.1973 8.53404 14.328 8.53404 14.46C8.53404 14.592 8.56018 14.7227 8.61095 14.8445C8.66171 14.9664 8.73611 15.077 8.82984 15.17Z" fill="#E40587" />
                              </svg>

                            </button>
                            <button onClick={() => { this.editCatHandle(cat) }} >
                              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                                <path d="M0 15.2501V19.0001H3.75L14.81 7.94006L11.06 4.19006L0 15.2501ZM17.71 5.04006C18.1 4.65006 18.1 4.02006 17.71 3.63006L15.37 1.29006C14.98 0.900059 14.35 0.900059 13.96 1.29006L12.13 3.12006L15.88 6.87006L17.71 5.04006Z" fill="#E40587" />
                              </svg>

                            </button>
                            <button onClick={() => { this.deleteCate(cat) }} className="delete_icon" >

                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="19" viewBox="0 0 14 19" fill="none">
                                <path d="M1 5V17.5C1 18.3284 1.67157 19 2.5 19H11.5C12.3284 19 13 18.3284 13 17.5V5H1Z" fill="#E40587" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9 1.5V1C9 0.447715 8.55228 0 8 0H6C5.44772 0 5 0.447715 5 1V1.5H0.5C0.223858 1.5 0 1.72386 0 2V2.5C0 2.77614 0.223858 3 0.5 3H13.5C13.7761 3 14 2.77614 14 2.5V2C14 1.72386 13.7761 1.5 13.5 1.5H9Z" fill="#E40587" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      ))
                      }</>
                    }
                  </div>



                </div>
              </div>
              {/* end of all services */}




            </div>
          </div> : ""}
      </>
    );
  }
}


export default withRouter(connect(mapStateToProps)(ManageCategories));
